'use client';

export const EyeButton = ({ className }: { className?: string }) => {
  return <p className={`${className || ''} bvi-open`}>Версия для слабовидящих</p>;
};